import React from 'react';

import { useState,useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PCI_SIF_GET } from '../../Utils/InfoUploadingConst';

function PCI_SIF_RPharmacy() {

 
  return (
    <div>

<div className="container mt-5 mb-5">
        <div className="row register" style={{ maxWidth: "100%" }}>
          <div className="col-md-12">
            <h3>
              PCI-SIF            
            </h3>
            <p>PCI-SIF documents Link are below</p>
          </div>

        
<div className="container">

  
<div className="alumni-area  pb-70">
<div className="row">


<div className="col-md-4">
<a href="https://s3.ap-south-1.amazonaws.com/document.swaminarayanuniversity.ac.in/university-assets/Standard+Inspection+Form-+SSIPR.pdf" target="_blank">
  <div className="single-alumoni-updates-card">
  <div className=" d-flex flex-row flex-wrap align-items-center ">
    <div className=" bg-danger text-center p-3 me-3">
    <i class="ri-file-download-line text-light " style={{fontSize:"20px"}}></i>
    </div>
   <div className="">
    <p>
       PCI-SIF 2025-26
    </p>
   </div>
  </div>
</div>
</a>
  </div>
 

</div>

</div>
</div>
         
        </div>
        <br />
        <br />
      </div>
      





{/* <div className="container register mb-5" style={{maxWidth:'1300px'}}>
  <div className="row">

  <div className="col-md-12">
      <h3> PCI-SIF List</h3>
  </div>

  <div className="row">

    {data
        .filter((item) => item.status == 'ACTIVE' && item.college_id == 1111008)
        .map((item, key) => (
            <div className="col-md-3 mt-5" key={key}>
              <h5>
              <a href={item?.attachments} target="_blank">
                {formatSession(item?.session)}
              </a>
              </h5>
            </div>
        ))
    }

    </div>
    
  </div>
</div> */}


    </div>
  )
}

export default PCI_SIF_RPharmacy;
